import { gql } from '@apollo/client';
import client from 'api/ApolloClient';
import { ApiMethod, get } from 'services/api';
import { useRestMutation, UseRestMutationOptions } from 'utils/hooks/api';
import { ApiKey } from 'modules/apiKeys/types';

export const GET_API_KEYS_QUERY = gql`
  query getApiKeys {
    apiKeys {
      creatorUserId
      createdAt
      updatedAt
      enabled
      jwtRequired
      keyHash
      keyType
      keyIdentifier
      projectId
      name
      customEventManageAllowCreationUntil
      lastUsedAt
    }
  }
`;

export type ApiKeysResponse = {
  data: {
    apiKeys: ApiKey[];
  };
  loading: boolean;
  networkStatus: number;
};

export const CREATE_API_KEY_URL = '/settings/apiKeys/create';
export const DELETE_API_KEY_URL = '/settings/apiKeys/delete';
export const EDIT_API_KEY_URL = '/settings/apiKeys/update';
export const API_KEYS_TYPES_URL = '/i/apiKeyTypes';

/**
 * Create an API Key -
 */
export const useCreateApiKey = (options?: UseRestMutationOptions) =>
  useRestMutation(CREATE_API_KEY_URL, ApiMethod.post, options);

/**
 * Delete an api key -
 */
export const useDeleteApiKey = (options?: UseRestMutationOptions) =>
  useRestMutation(DELETE_API_KEY_URL, ApiMethod.post, options);

/**
 * Edit an API key
 */
export const useEditApiKey = (options?: UseRestMutationOptions) =>
  useRestMutation(EDIT_API_KEY_URL, ApiMethod.post, options);

/**
 * Fetch the API keys
 */
export const fetchApiKeys = (): Promise<ApiKeysResponse> =>
  client.query({
    query: GET_API_KEYS_QUERY,
  });

/**
 * Feth API Key Types for create/edit forms
 */
export const fetchApiKeyTypes = () => get(API_KEYS_TYPES_URL);
